import React, { useRef } from "react";
import { userLanguage } from "data/storeHelper";

type Props = {
    /** uppy instance reference */
    uppy: Object,
    /** url to custom page providing file selection */
    url: string,
    /** callback to close custom panel */
    onClose: () => void,
};

const CustomUploadSelection = (props: Props) => {
    const iframeRef = useRef(null);

    // TODO currently data supported is only blob; in the future also URL to self download
    /* istanbul ignore next */ function cbAddFile(name, data) {
        props.uppy.addFile({
            name, // file name
            // type: 'image/jpeg', // file type
            data, // file blob
            source: "Local", // optional, determines the source of the file, for example, Instagram
            isRemote: false, // optional, set to true if actual file is not in the browser, but on some remote server, for example, when using companion in combination with Instagram
        });
        if (typeof props.onClose === "function") props.onClose();
        // alert("will add " + name);
    }

    /* istanbul ignore next */ function frameLoaded() {
        if (iframeRef.current && iframeRef.current.contentWindow) {
            if (typeof iframeRef.current.contentWindow.start === "function")
                iframeRef.current.contentWindow.start({
                    cbAddFile,
                    language: userLanguage(),
                });
            else
                console.warn(
                    "Loaded CustomUploadSelection at " +
                        props.url +
                        " has no start() method"
                );
        }
    }

    return (
        <iframe
            ref={iframeRef}
            onLoad={frameLoaded}
            title="itemFlow custom"
            width="100%"
            height="100%"
            frameBorder="0"
            allowFullScreen={true}
            src={props.url}
        />
    );
};
CustomUploadSelection.displayName = "ItemFlows.CustomUploadSelection";
export default CustomUploadSelection;
